import { keepPreviousData, skipToken, useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import { courtHearingsApi } from "@/api";
import { withLocalErrorHandling } from "@/api/middleware/errorMiddleware";
import { QueryKey } from "@/query/Query";

import { CourtHearingsSearchParams } from "../CourtHearings.types";

const QUERY_DATE_FORMAT = "yyyy-MM-dd";

export function courtHearingsQueryKey(params: CourtHearingsSearchParams | null) {
  return [
    QueryKey.CourtHearings,
    params ? format(params.from, QUERY_DATE_FORMAT) : null,
    params ? format(params.to, QUERY_DATE_FORMAT) : null,
    params?.courtId ?? null,
    params?.counselorId ?? null,
  ];
}

export function useCourtHearingsQuery(params: CourtHearingsSearchParams | null) {
  return useQuery({
    queryKey: courtHearingsQueryKey(params),
    queryFn:
      params === null
        ? skipToken
        : () =>
            courtHearingsApi.getCourtHearings(
              {
                from: params.from,
                to: params.to,
                courtId: params.courtId,
                counselorId: params.counselorId,
              },
              // The failure is shown in place of the report, so it must not also raise the global toast.
              withLocalErrorHandling
            ),
    // The filters apply live, so the report stays on screen while the next period or filter loads
    // instead of blanking on every keystroke.
    placeholderData: keepPreviousData,
  });
}
